<style lang="stylus" src='./mixins/stylus/global.styl'></style>

<script>
  import { createApp, mpx } from '@didi/es-mpx-creator'
  import '@/common/global_use'
  import usex from '@/config/usex'
  // 先注册不然其他模块有引入的api会找不到
  import { getStorage } from './utils/storage'
  import store from '@/store'
  // import '@/common/updateManager' // 这里的顺序要保证放在mpx 引入后面
  import '@/common/raven-init/init' // 这里的顺序要保证放在mpx 引入后面
  import raven, { addRavenPhoneAndUid } from '@/common/raven-init/init'
  import { bridge, locate, getURL, is } from '@didi/webx-js'
  import { initWebx } from '@/common/webx'
  import usexStore from '@/config/usex/lib/store'
  import { parseQuery, stringifyQuery } from '@didi/es-mpx-shared'
  import { trackEvent } from '@/common/track'
  import { trackPageView } from '@didi/spring-base'

  mpx.mixin(
    {
      ready() {
        trackPageView()
      },
    },
    'page',
  )
  function getPlugins() {
    const context = require.context('@/plugins', true, /\.js$/)
    return context.keys().map((path) => context(path).default)
  }
  function hideNativeBar() {
    if(__mpx_mode__ === 'web') {
      const needNativeBarPages = [
        '/pages/calendar/index',
        '/pages/train-city/index',
        '/pages/agreement/index'
      ]
      const currentPage = window.location.pathname
      if (bridge && !needNativeBarPages.includes(currentPage)) {
        bridge.hideNativeBar && bridge.hideNativeBar({}, (result) => {
          if (result.statusBarHeight) {
            store.mutations.common.setSafeArea(result.statusBarHeight)
          }
        })
      }
    }
  }
  createApp({
    plugins: [usex, ...getPlugins()],
    globalData: {
      hasLogin: false
    },
    async onLaunch(options) {
      console.log('%c [ onLaunch ]-54', 'font-size:13px; background:pink; color:#bf2c9f;', 'onLaunch')
      hideNativeBar()
      raven.trackEvent('app_launch_options_info', { options })
      initWebx().then((xpsmInfo) => {
        store.commit("common.setXpsmInfo", xpsmInfo);
      })
      if (
        __mpx_mode__ == 'web' &&
        (window.location?.href?.indexOf('pre-release-') > -1 ||
          window.location?.href?.indexOf('8082') > -1) ||
          window.location?.href?.indexOf('10.190.55.97') > -1 ||
          window.location?.href?.indexOf('pre-railway') > -1 
      ) {
        import('vconsole').then((VConsole) => {
          // h5预发环境临时加vconsole
          const cotr = VConsole?.default || VConsole
          const vConsole = new cotr()
        })
      }
      const { pathname, search } = window.location || {}
      const { ticket, token, ...other } = parseQuery(search) || {}
      trackEvent('user-token-init', '排查--用户token初始化--parseQuery执行', { ticket, token })
      if (ticket || token) {
        try {
          mpx.setStorageSync('userInfo', { token: ticket || token })
          mpx.setStorageSync('token', token || ticket)
        } catch (e) {
          // 埋点 ticket确实排查--- 先用@/common/track
          trackEvent('yks_local_storage_set_or_get_ck', 'yks_local_storage_set_or_get_ck', {
            type: 'set_local_storage_error',
            errtext: e && e.message,
          })
        }
      }
      this.setLocation()
      //检测用户是否登陆 并更新stata与storage的值
      // await usexStore.dispatch('getToken', false)
      const noNeedLoginUrl = ['/home/index', '/search/list', '/train-city', 'calendar/index']
      const isNoNeedLoginUrl = noNeedLoginUrl.some((url) => {
        return getURL().indexOf(url) > -1
      })
      const isAli = is('alipay') || is('alimp')
      // 整改需求
      const noNeedLogin = isNoNeedLoginUrl && isAli
      await usexStore.dispatch('getToken', !noNeedLogin).then((res) => {
        addRavenPhoneAndUid(res)
        trackEvent('user-token-finish', '排查--用户token初始化--结束', { res })
      })
    },
    /**
     * @description: 全局错误事件
     */
    onError(error) {
      console.error('发生错误：----  ', error)
    },
    /**
     * @description: 小程序有未处理的 Promise 拒绝时触发, async函数内部错误导致阻塞执行，接口的promise reject等
     * */
    onUnhandledRejection({ reason }) {
      try {
        raven.trackError('unhandled_rejection', {
          source: 'App.onError',
          error: reason
        })
      } catch (e) {
        console.log('onUnhandledRejection======>', e)
      }
    },
    onShow(data) {
      raven.trackEvent('app_lifecycle', {
        type: 'onShow',
        options: data
      })
    },
    onHide() {
      raven.trackEvent('app_lifecycle', { type: 'onHide' })
    },
    // 定位相关
    setLocation() {
      locate({ useQuickOption: 'city' }).then(res => {
        console.log('locate',res);
        trackEvent('user-location-init', '排查--用户location初始化--locate执行', { locate: res })
        store.commit("common.setLocationInfo", res);
        store.dispatch("travel.setDefaultCityList", res?.cityId);
      }).catch((e)=>{
        console.log('locate失败',e);
        store.dispatch("travel.setDefaultCityList", null);
      })
    },
  })
</script>

<script name="json">
  const config = {
    pages: [
      './pages/home',
      // './pages/demo',
      './pages/login12306/verification-code',
      './pages/login12306/witness-verification',
      './pages/login12306/index',
      './pages/login12306/password-modification',
      './pages/login12306/submit-rm',
      './pages/login12306/register',
      './pages/train-city/index',
      './pages/train-detail/index',
      './pages/upload',
      './pages/jump',
      './pages/agreement/index',
      './pages/webview',
      './pages/index',
      './pages/success',
      './pages/make-order/index',
      './pages/make-order/index-backup',
      './pages/login12306/password-retrieval',
      './pages/component-demo',
      './pages/refund-ticket/refund-ticket-detail-page',
      './pages/change-ticket/change-ticket-page',
      './pages/change-ticket/change-ticket-detail-page',
      './pages/search/list',
      './pages/order/detail',
      './pages/order/occupy-failed', // 占座失败
      './pages/home/service',
      './pages/contact/select', // 选择乘车人页面
      './pages/contact/add', // 添加乘车人页面
      './pages/contact/edit', // 编辑乘车人页面
      './pages/contact/selectCountry', // 选择国家或地区
      './pages/order-list/index', // 订单列表
      './pages/ticket-purchase-notice/index', // 购票须知页面
      './pages/passenger/passenger-contact-verify-page.mpx',
      './pages/passenger/passenger-identity-verify-page.mpx',
      './pages/order/refund-offline',
      './pages/tickets12306/order-list',
      './pages/tickets12306/order-detail',
      './pages/calendar/index',
      './pages/share/index',
    ],

    packages: [],
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-calendar': '@didi/es-mpx-ui/lib/calendar',
      'es-layout': './es-mpx-ui/lib/scroll-layout',
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog',
      'es-checkbox': './es-mpx-ui/lib/checkbox',
      'es-navbar': './es-mpx-ui/lib/navbar'
    },
    permission: {
      'scope.userLocation': {
        desc: '您的位置信息将用于获取用车地点信息'
      }
    },
    window: {
      navigationStyle: 'custom'
    }
  }
  module.exports = config
</script>
